<template>
  <div class="shop main-top-border main-bg">
    <div class="main-wrap mt20" style="background-color:#f7f6f9;overflow: hidden;">
      <div class="fl">
        <el-table
                class="tab-list"
                :data="shopList"
                @cell-click="goShopDetail"
                :default-sort = "{prop: 'address', order: 'descending'}"
                :header-row--classname='headerStyle'
                :header-row-style="{'background-color':'#EBF3EE','border':'1px solid #E0E0E0'}"
                :header-cell-style="{
                  'background-color':'#EBF3EE',
                  'font-size':'14px',
                  'color':'#333333',
                  'height':'40px',
                  'padding':'0px',
                  'text-align':'center',
                  'font-weight':'500'
              }"
        >
          <el-table-column
                  label="店铺名称"
                  align="left"
                  class-name="cell-blue"
                  width="300px"
          >
            <template slot-scope="prop">
              <div>
                <el-image class="goods-img"  :src="$common.imgPath(prop.row.shopImg?prop.row.shopImg:prop.row.headImg)" :alt="prop.row.shopName" lazy></el-image>
                <div class="shop-name">{{prop.row.shopName}}</div>
              </div>
            </template>
          </el-table-column>
          <!--<el-table-column
                  prop="celebrityName"
                  label="商家"
                  width="180"
                  class-name="cell-blue"
                  align="center">
          </el-table-column>-->
          <el-table-column
                  prop="address"
                  label="所在地"
                  sortable
                  align="center">

          </el-table-column>
          <el-table-column
                  prop="starNum"
                  label="商家评分"
                  sortable
                  class-name="cell-yellow"
                  align="center"
          >
          </el-table-column>
        </el-table>
        <el-pagination
                @current-change="handleCurrentChange"
                :current-page="ruleForm.current"
                layout=" prev, pager, next,total, jumper"
                style="text-align: center;padding:20px;"
                :total="total">
        </el-pagination>
      </div>

      <div class="fr">
        <div class="search-box">
          <h3 class="title-name">搜索店铺</h3>
          <el-form :model="ruleForm" status-icon :rules="rules" ref="searchForm" label-width="80px" class="form-style">
            <el-form-item label="店铺名" prop="shopName" class="input-item">
              <input class="inp-txt" v-model="ruleForm.shopName" />
            </el-form-item>
            <!--<el-form-item label="商家名" prop="business" class="input-item">
              <input type="text" class="inp-txt" v-model="ruleForm.business" autocomplete="off" />
              &lt;!&ndash;<el-input type="password" v-model="ruleForm.business" autocomplete="off"></el-input>&ndash;&gt;
            </el-form-item>
            <el-form-item label="所在地" prop="address" class="input-item">
              <input type="text" class="inp-txt" v-model="ruleForm.address" autocomplete="off" />
              &lt;!&ndash;<el-input v-model.number="ruleForm.address"></el-input>&ndash;&gt;
            </el-form-item>-->
            <div style="text-align: center;">
              <button type="button" class="btn-submit" @click="submitForm('searchForm')">提交</button>
            </div>
          </el-form>
        </div>
        <!--<div class="extend-list">
          <h3 class="title-name">店铺推广</h3>
          <ul class="extend-ul">
            <li class="extend-item">子哈按原</li>
            <li class="extend-item">子哈按原</li>
            <li class="extend-item">子哈按原</li>
          </ul>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
  import Rule from '../../utils/rules'
    import {getShopPageList} from '../../api/shop'
  export default {
      data(){
          return {
              shopList:[],
              total:0,
              current:1,
              size:10,
              ruleForm:{
                  rank:1,
                  shopName:'',
                  /*business:'',
                  address:''*/
              },
              rules: {
                  shopName: Rule.required('请输入店铺名',false),
                  /*business: Rule.required('请输入商家名',false),
                  address:Rule.required('请输入所在地',false)*/
              }
          }
      },
      components:{

      },
      mounted () {
          this.getShopList();
      },
      methods:{
          goShopDetail(row, column, cell, event){
              this.$router.push({path:`/shop/detail/${row.shopId}`})
          },
          handleCurrentChange(current){
              this.current=current;
              this.getShopList();
          },
          headerStyle(){
              return 'tabHead';
          },
          getShopList(){
              const form = JSON.parse(JSON.stringify(this.ruleForm));
              if(form.shopName == ''){
                  delete form.shopName;
              }
              getShopPageList({
                  current:this.current,
                  size:this.size,
                  ...form
              }).then(res=>{
                  const {records,total} = res.data;
                  this.total=total;
                  this.shopList=records;
              })
          },
          submitForm(formName) {
              this.$refs[formName].validate((valid) => {
                  if (valid) {
                      this.current=1;
                      this.getShopList();
                  } else {
                      console.log('error submit!!');
                      return false;
                  }
              });
          }
      }
  }
</script>
<style lang="scss" scoped>
  @import '../../assets/css/common';
  .search-box{background-color:#ffffff;}
  .form-style{
    padding-top:21px;
  }
  .title-name{
    width:334px;
    height:40px;
    line-height:40px;
    padding-left:20px;
    color:#ffffff;
    font-size:18px;
    background-color:$main-color;
    font-weight:600;
  }
  .inp-txt{
    border:1px solid #E0E0E0;
    background-color:#F7F7F7;
    width:228px;
    height:28px;
  }
  .btn-submit{
    width:98px;
    height:34px;
    border:1px solid #CBCBCB;
    font-size:18px;
    color:#333333;
    margin:16px 0 33px 0;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
  }
  .extend-list{
    background-color:#ffffff;
    .extend-ul{
      padding:20px;
      .extend-item{
        padding-bottom:13px;
        color:#1457D1;
        font-size:16px;
      }
    }

  }
</style>
<style lang="scss">
.tabHead{
  border:1px solid #E0E0E0;
  background-color:#EBF3EE;
  font-size:14px;
  color:#333333;
}
  .input-item{
    margin-bottom:10px;
  }
.tab-list{
  width:825px;
  position: relative;
  background-color:#ffffff;
  .shop-name{
    display: inline-block;padding-left:10px;
    width:95px;
    }
  .goods-img{
    vertical-align: middle;
    width:100px;
    height:100px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
  }
}
</style>
